import { Navigate, useLocation } from "react-router-dom";

/** Preserves hash and query when redirecting legacy /join URLs to /features. */
export default function LegacyJoinRedirect() {
  const location = useLocation();
  return (
    <Navigate
      to={{ pathname: "/features", hash: location.hash, search: location.search }}
      replace
    />
  );
}
